import React from 'react';
import { Link } from 'react-router-dom';
import PropTypes from 'prop-types';
import { useTranslation } from 'react-i18next';

import './SuccessScreen.scss';

const SuccessScreen = (props) => {
  const { t } = useTranslation();
  return (
    <div className="success-screen">
      {props.data.svg ? (
        <props.data.svg />
      ) : (
        <div className="success-icon">
          <i className="material-icons md-48">done</i>
        </div>
      )}

      {props.data.copyDynamic ? (
        <div>
          <h4 className="success-message">{t(props.data.copy, props.data.copyDynamic)}</h4>
        </div>
      ) : (
        <h4
          className="success-message"
          dangerouslySetInnerHTML={{ __html: t(props.data.copy) }}></h4>
      )}

      {props.data.message && <p>{t(props.data.message, props.data.messageDynamic)}</p>}

      {props.data.link &&
        (props.data.reloadLinkPage ? (
          <a
            href={props.data.link}
            className={`btn ${props.data.buttonClass ? props.data.buttonClass : 'btn-outline'}`}
            rel="noreferrer noopener">
            {t(props.data.buttonLabel)}
          </a>
        ) : (
          <Link
            to={props.data.link}
            className={`btn ${props.data.buttonClass ? props.data.buttonClass : 'btn-outline'}`}>
            {t(props.data.buttonLabel)}
          </Link>
        ))}

      {props.data.callback && (
        <button
          className={`btn ${props.data.buttonClass ? props.data.buttonClass : 'btn-outline'}`}
          onClick={props.data.callback}>
          {t(props.data.buttonLabel)}
        </button>
      )}
    </div>
  );
};

export default SuccessScreen;

SuccessScreen.propTypes = {
  data: PropTypes.shape({
    copy: PropTypes.string.isRequired,
    copyDynamic: PropTypes.shape({}),
    link: PropTypes.string,
    callback: PropTypes.func,
    buttonLabel: PropTypes.string.isRequired,
    buttonClass: PropTypes.string,
    message: PropTypes.string,
    messageDynamic: PropTypes.shape({}),
    svg: PropTypes.func,
    reloadLinkPage: PropTypes.bool,
  }).isRequired,
};
